<template>
  <div class="transaction-currency-component" :class="{ disabled }">
    <div
      :class="{'active': currentMoneyType === 'cash' }"
      class="cash-section"
      @click="currentMoneyType = 'cash'"
    >
      <div class="currency-content">
        <span class="label">Наличные</span>
        <span v-if="getCashBalance !== null" class="cash font-weight-medium">
          {{ getCashBalance | amountInRub }}
        </span>
      </div>
      <div class="icon">
        <icon-cashier />
      </div>
      <transition name="fadeLeft">
        <div v-if="currentMoneyType === 'cash'" class="icon-check">
          <font-awesome-icon icon="check" color="#ffffff" />
        </div>
      </transition>
    </div>
    <div
      v-if="!hideChecks"
      :class="{'active': currentMoneyType === 'terminal' }"
      class="terminal-section"
      @click="currentMoneyType = 'terminal'"
    >
      <div class="currency-content">
        <span class="label">Терминал</span>
        <span class="terminal-money font-weight-medium">{{ getTerminalChecksBalance | amountInRub }}</span>
        <span class="terminal-receipt font-weight-medium">Чеков: {{ getTerminalChecksQuantity }}</span>
      </div>
      <div class="icon">
        <icon-terminal />
      </div>
      <transition name="fadeLeft">
        <div v-if="currentMoneyType === 'terminal'" class="icon-check">
          <font-awesome-icon icon="check" color="#ffffff" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import IconCashier from '@/components/icons/IconCashier'
  import IconTerminal from '@/components/icons/IconTerminal'

  export default {
    name: 'TransactionCurrency',
    components: {
      IconCashier,
      IconTerminal,
    },
    model: {
      prop: 'value',
      event: 'change',
    },
    props: {
      value: {
        type: String,
        default: 'cash',
      },
      transaction: {
        type: Object,
        default: () => ({}),
      },
      hideChecks: Boolean,
      disabled: Boolean,
    },
    computed: {
      currentMoneyType: {
        get () {
          return this.value
        },
        set (value) {
          if (this.disabled) return
          this.$emit('change', value)
        },
      },
      getCashBalance () {
        try {
          return this.transaction.senderBalance.cashBalance
        } catch {
          return 0
        }
      },
      getTerminalChecksBalance () {
        try {
          return this.transaction.senderBalance.terminalChecksBalance
        } catch {
          return 0
        }
      },
      getTerminalChecksQuantity () {
        try {
          return this.transaction.senderBalance.terminalChecksQuantity
        } catch {
          return 0
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  .transaction-currency-component {
    &.disabled {
      .cash-section,
      .terminal-section {
        cursor: default;
      }
    }

    .cash-section,
    .terminal-section {
      position: relative;
      border-radius: 10px;
      padding: 20px 15px 10px 65px;
      cursor: pointer;
      transition: box-shadow 0.2s ease;
      background-color: #D8DBE6;
      height: 144px;
      z-index: 0;

      span {
        display: block;
      }
    }

    .cash-section {
      margin: 24px 0;

      .cash {
        font-size: 32px;
        line-height: 1;
      }
    }

    .terminal-section {
      .terminal-money {
        font-size: 32px;
        line-height: 1;
      }

      .terminal-receipt {
        font-size: 18px;
      }
    }

    .icon {
      position: absolute;
      top: 0;
      left: 10px;
      bottom: 0;
      margin: auto;
      z-index: -1;
      height: 100px;

      svg {
        max-height: 100px;
      }
    }

    .icon-check {
      position: absolute;
      right: 13px;
      top: 11px;
      width: 35px;
      height: 35px;
      background-color: #368D3A;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
